/**
 * idはoriginalIdではないので注意すること
 */
export class FormatStatus {
  constructor(
    public originalId: number,
    /** originalIdではないので注意すること */
    public id: number,
    public name: string,
    public expired: boolean,
    public deleted: boolean) {
  }

  clone() {
    return new FormatStatus(
      this.originalId,
      this.id,
      this.name,
      this.expired,
      this.deleted,
    );
  }
}
